import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { DialogService, DialogRef, DialogSettings, DialogCloseResult, WindowService, WindowSettings } from '@progress/kendo-angular-dialog';
import { EntityComponent } from '../../literals/entity-components.literal';
import { FormGroup } from '@angular/forms';
import { TabControl } from '../../ui/controls/tab-control.model';
import { UiColumn } from '../../ui/ui-column';
import { DetailService } from '@core/services/detail.service';
import { FeedbackMessageService } from '@shared/services/feedback-message.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { getLocaleCurrencyCode } from '@angular/common';
import { PagingAction, PagingOptions } from '../../interfaces/tab-option.interface';
import { EntityService } from '@shared/services/entity.service';
import { ToolbarItem } from '../../interfaces/tool-bar-item.interface';
import { faEdit, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { BaseControl } from '../../ui/controls/base-control.model';
import { GridControl } from '../../ui/controls/grid-control.model';
import { GridModule } from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-grid-kendo-card',
    imports: [GridModule, TranslateModule],
    templateUrl: './grid-kendo-card.component.html',
    styleUrl: './grid-kendo-card.component.css'
})
export class GridKendoCardComponent implements OnInit {

  @Input() tab: TabControl;
  @Input() data: Array<any>;
  @Output() dataChange: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  @ViewChild("tabTable", { static: true }) public table: ElementRef;

  gridData: Array<any>;
  total: number;

  showAddBtn: boolean = true;

  linkTarget: string = "_blank";
  icoEdit: IconDefinition = faEdit;
  icoDelete: IconDefinition = faX;

  @Input() control: BaseControl;
  gridControl: GridControl;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.gridControl = this.control as GridControl;
    this.gridData = this.gridControl.gridOptions.data;
  }

  ngOnChanges() {
    this.gridControl = this.control as GridControl;
    this.gridData = this.gridControl.gridOptions.data;
  }

  getConvertedItemValue(value: any, format: string | undefined): string {
    if (value === true || value === "true" || value === "True") {
      return "Yes";
    } else if (value === false || value === "false" || value === "False") {
      return "No";
    } else {
      if (format != undefined && value != null) {
        var isCurrencyFormat: boolean = format == "{0:C}";
        var isDateFormat: boolean = format.includes("MM/dd/yyyy") || format.includes("DD/mm/yyyy") || format.includes("yyyy/dd/MM");
        var isNumberFormat: boolean = format == "{0:N2}";

        var browserLanguage = this.translateService.getBrowserCultureLang();

        if (isCurrencyFormat) {
          if (browserLanguage != undefined) {
            const currencyFormatter = new Intl.NumberFormat(browserLanguage, {
              style: 'currency',
              currency: getLocaleCurrencyCode(browserLanguage) ?? "USD"
            });

            value = currencyFormatter.format(value);
          }
        } else if (isDateFormat) {
          var options: Intl.DateTimeFormatOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          };

          if (format.includes("hh")) {
            options.hour = "2-digit";
          }

          if (format.includes("mm")) {
            options.minute = "2-digit";
          }

          if (format.includes("ss")) {
            options.second = "2-digit";
          }

          var dateFormatter = new Intl.DateTimeFormat(browserLanguage, options);

          if (!value.toString().includes('Z')) {
            value = value + 'Z';
          }

          var date = new Date(value);
          var offset = date.getTimezoneOffset();
          value = dateFormatter.format(date);

        } else if (isNumberFormat) {
          var numberFormatter = new Intl.NumberFormat(browserLanguage, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });

          value = numberFormatter.format(value);
        } else {
          value = value;
        }
      }

      return value;
    }
  }
}

declare global {
  interface Array<T> {
    skip(size: number): T[];
    take(size: number): T[];
    chunk(size: number): T[];
  }
}

Array.prototype.skip = function (size: number) {

  var tempArray = this;
  var remaining = tempArray.length - size;
  tempArray = tempArray.slice(size, remaining);

  return tempArray;
}

Array.prototype.take = function (size: number) {

  var tempArray = this;
  tempArray = tempArray.slice(0, size);

  return tempArray;
}

Array.prototype.chunk = function (size: number) {

  var arr = [];
  for (var i = 0; i < this.length; i += size) {
    arr.push(this.slice(i, i + size));
  }

  return arr;

}
